import table from './table'

export default {
    id: 'Zahlungslauf #{id}',

    changeDataWarning: 'Wenn Zahlungsdaten (betrifft nicht "Interner Kommentar") geändert werden, werden automatisch die Dokumente neu generiert.',

    formProcesses: 'Formulare',
    payments: 'Zahlungen',

    organisation_id: 'Verband-ID',
    funding_program_id: 'Förderprogramm-ID',
    year_id: 'Jahr',
    year: 'Jahr',
    customAmount: 'Manueller Betrag',
    fixedAmount: 'Fester Betrag',
    user_id: 'Nutzer-ID',
    pdf_document_id: 'PDF-Dokument-ID',

    organisation_name: 'Verband',
    organisationName: 'Verband',
    sum: 'Gesamtbetrag',
    costCenterNumber: 'Kostenstellen-Nummer',
    cost_center_number: 'Kostenstellen-Nummer',
    costCenterName: 'Kostenstellen-Name',
    cost_center_name: 'Kostenstellen-Name',
    booking_date: 'Buchungsdatum',
    bookingDate: 'Buchungsdatum',
    search: 'Such-Spalte',

    intended_use: 'Verwendungszweck',
    intendedUse: 'Verwendungszweck',
    percentage: 'Prozentsatz',
    roundDownToTens: "Auf Zehner runden",
    round_down_to_tens: "Auf Zehner runden",
    valueRoundDownToTens: 'Abgerundet auf Zehner',
    valueRoundDownToTensDescription: 'Die Zahlung wurde auf den nächst niedrigeren Zehner abgerundet.',
    reachedMaxPayable: 'Die Zuschusshöhe wurde erreicht',
    reachedMaxPayableDescription: 'Die Zuschusshöhe wurde erreicht und konnte nicht überschritten werden.',
    comment: 'Interner Kommentar',

    is_sage_export: 'SAGE-Export',
    status: 'Status',

    subsidy_amount: 'Zuschusshöhe',

    saveSuccess: 'Zahlungslauf erfolgreich gespeichert',

    exportSage: 'Nach SAGE exportieren',
    exportSuccess: 'Zahlungslauf erfolgreich exportiert',
    exportError: 'Fehler beim Exportieren des Zahlungslaufs',

    exportStatuses: {
        pending: 'Ausstehend',
        exported: 'Exportiert',
        failed: 'Fehlgeschlagen',
    },

    table,

    menu: {
        paymentRunBaseData: 'Daten',
        paymentRunPayments: 'Zahlungen',
        paymentRunActivities: 'Historie',
    }
}